import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import {
  Box,
  Typography,
  Button,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import apiHelper from "../../../../util/ApiHelper";
import { toast } from "react-toastify";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { useLoading } from "../../../../util/LoadingProvider";


const useStylesAll = makeStyles((theme) => ({
  root: {
    margin: 0,
    marginBottom: 20,
    minWidth: "100%",
  },
  leftGrid: {
    maxHeight: 100,
  },
  last: {
    margin: 0,
    marginTop: theme.spacing(3),
  },
  topBar: {
    padding: 0,
  },
  pagination: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
  "&::placeholder": {
    color: "grey",
  },
}));

export default function OrganizationEmployeePagesForm({ disabled, ...props }) {
  const { history, fetchData } = props;
  const classes = useStylesAll();
  let { id } = useParams();

  const { control, handleSubmit, setValue } = useForm();
  const { setLoading } = useLoading();

  const [positionList, setPositionList] = React.useState([]);
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const formatRowToData = (row) => {
    return {
      employeeNameEn: row.employeeNameEn,
      employeeNameTc: row.employeeNameTc,
      positionId: row.positionId,
    }
  }

  const getAllPositions = async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getPositions({
        pageSize: 99999,
    });
      setPositionList(result.data.content);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllPositions();
    if (id) {
      apiHelper.hkiff
        .getEmployeeById(id)
        .then((response) => {
          console.log(response.data);
          setValue("employeeNameEn", response.data.employeeNameEn);
          setValue("employeeNameTc", response.data.employeeNameTc);
          setValue("positionId", response.data.positionId);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, []);

  const updateEmployee = async (data) => {
    console.log(data);
    console.log(formatRowToData(data));
    try {
      const result = await apiHelper.hkiff.updateEmployeeById(
        id, formatRowToData(data)
      );
      console.log(result.data);
      toast.dark("Your changes is saved.");
      history.push("/hkiff/organization/employee");
    } catch (err) {
      console.log(err);
    }
  };

  const createEmployee = async (data) => {
    console.log(data);
    console.log(formatRowToData(data));
    try {
      const result = await apiHelper.hkiff.createEmployee(
        formatRowToData(data)
      );
      if (result.data.code === -4) {
        toast.error("Duplicated group code.");
      } else {
        toast.dark("Employee created.");

        //clear all fields
        setValue("employeeNameEn", "");
        setValue("employeeNameTc", "");
        setValue("positionId", null);
        fetchData();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onSubmit = (data) => {
    const sendEmployee = () => {
      if (id) {
        updateEmployee(data);
      } else {
        createEmployee(data);
      }
    };
    sendEmployee();
  };

  return (
    <>
      <Box fontWeight={900} fontSize={13} mb={2} width="100%">
        <Typography variant="p">{props.description}</Typography>
      </Box>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled} className="fieldset">
          <Box width="100%">
            <Controller
              control={control}
              name="employeeNameEn"
              defaultValue=""
              render={({ field }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Name (English)"
                    variant="outlined"
                    helperText="The name is how it appears on your site."
                    {...field}
                    fullWidth
                  />
                );
              }}
            />
            <Controller
              control={control}
              name="employeeNameTc"
              defaultValue=""
              render={({ field }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Name (Traditional Chinese)"
                    variant="outlined"
                    helperText="The name is how it appears on your site."
                    {...field}
                    fullWidth
                  />
                );
              }}
            />

            <Controller
              name="positionId"
              defaultValue=""
              control={control}
              render={({ field, fieldState: { error } }) => (
                <FormControl
                  className={classes.formControl}
                  fullWidth
                  variant="outlined"
                  margin="dense"
                >
                  <Select
                    {...field}
                    
                    MenuProps={MenuProps}
                  >
                    {positionList &&
                      positionList.map((gp) => (
                        <MenuItem key={gp.id} value={gp.id}>
                          {gp.positionNameEn}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              )}
            />

            <Box display="flex" alignItems="flex-end" alignContent="flex-end">
              {disabled || (
                <Box>
                  <Button
                    className={classes.last}
                    variant="contained"
                    color="primary"
                    size="large"
                    type="submit"
                  >
                    {props.submitBtnTxt}
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
        </fieldset>
      </form>
    </>
  );
}
